module.exports = __webpack_public_path__ + "img/agenda.229d8ee9.svg";